// Import necessary React hooks
import { useState } from "react";
// Import necessary Material-UI components
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";

import {
  CustomFilePicker,
  downloadBulkUploadTemplate,
  LoadingButtonText,
} from "../../../common/index.js";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { extractExcelData } from "../../functions/extractExcelData.js";
import { useResubmitRequest } from "./hooks/useResubmitRequest.hook.js";
import { useResubmitRequestContext } from "./hooks/useResubmitRequestContext.hook.js";

export function ResubmitAddItemsInBulkSampleRequestModal(props) {
  // State to store any validation errors
  const [errors, setErrors] = useState();
  // Hook to set sample request details
  const { setSampleRequestDetails } = useResubmitRequest();
  // Hook to access the current state of the new request
  const { state } = useResubmitRequestContext();
  // State to store new excel file to be processed
  const [excelFile, setExcelFile] = useState([]);
  // State to track the excel template download in progress
  const [isDownloadingTemplate, setIsDownloadingTemplate] = useState(false);

  const handleDownloadTemplate = async () => {
    setIsDownloadingTemplate(true);
    try {
      await downloadBulkUploadTemplate();
    } finally {
      setIsDownloadingTemplate(false);
    }
  };

  // Function to close the modal
  const handleClose = () => {
    props.setOpen(false);
    setExcelFile([]);
    setErrors({});
  };

  // Function to handle form submission for adding a new item
  const handleSetData = async (data) => {
    // Reset any existing errors
    setErrors({});

    // Update the sample request details with the new data, including the compressed images
    setSampleRequestDetails({
      ...state.sampleRequestDetails,
      items: [...state.sampleRequestDetails.items, ...data],
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const jsonData = await extractExcelData(excelFile[0]);
      handleSetData(jsonData);
      handleClose();
    } catch (error) {
      setErrors(error);
    }

    console.log(errors, "error");
  };
  errors && console.log({ errors });

  return (
    <div>
      <Dialog
        open={props.open}
        onClose={handleClose}
        style={{
          height: "90%",
        }}
        PaperProps={{ sx: { borderRadius: "20px" } }}
      >
        <Box
          sx={{
            display: props.display,
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Container
            component="main"
            maxWidth="sm"
            sx={{
              marginTop: 4,
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography component="h1" variant="h5">
              Add Items in bulk
            </Typography>
            <CssBaseline />

            <Box
              component="form"
              noValidate
              sx={{
                mt: 2,
              }}
            >
              <Grid item xs={12}>
                <Button
                  onClick={handleDownloadTemplate}
                  disabled={isDownloadingTemplate}
                  variant="outlined"
                  sx={{
                    mb: 3,
                    textTransform: "capitalize",
                  }}
                  startIcon={!isDownloadingTemplate && <CloudDownloadIcon />}
                >
                  <LoadingButtonText
                    loading={isDownloadingTemplate}
                    text="Download Excel Template"
                  />
                </Button>
              </Grid>
              <Grid item xs={12} sx={{ mt: "-10px" }}>
                {/* Render a CustomFilePicker component for selecting excel file */}
                <CustomFilePicker
                  error={errors && errors.excelFile}
                  selectedFiles={excelFile}
                  setSelectedFiles={setExcelFile}
                  pickerId="Excel "
                  multiple={false}
                  fileType=".xlsx"
                />
              </Grid>
              <Grid
                container
                spacing={2}
                sx={{
                  mt: 1,

                  flexDirection: "row",
                  justifyContent: "center",
                }}
              >
                <Grid item>
                  <Button
                    onClick={handleClose}
                    variant="contained"
                    sx={{
                      mt: 3,
                      mb: 3,
                      width: "150px",
                      textTransform: "capitalize",
                    }}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    onClick={handleSubmit}
                    variant="contained"
                    sx={{
                      mt: 3,
                      mb: 3,
                      width: "150px",
                      textTransform: "capitalize",
                    }}
                  >
                    Confirm
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Container>
        </Box>
      </Dialog>
    </div>
  );
}
